import session from './session'
import format from 'string-format'

export default {

  /**
   * Получить из REST список наборов баркодов (только id и название).
   * @returns {AxiosPromise<any>}
   */
  listBarcodeSet() {
    return session.get('/barcodeSets/')
  },


  /**
   * Получить из REST данные/списки баркодов наборов баркодов
   *
   * @param barcodeSet_set Set() названий наборов баркодов
   * @returns {AxiosPromise<any>}
   */
  getBarcodeSets(barcodeSet_set) {
    let barcode_set_promises = []
    barcodeSet_set.forEach(
      x => barcode_set_promises.push(
        session.get(
          format(
            '/barcodeSets/{barcodeSet_name}/',
            {'barcodeSet_name': x})
        )
      )
    )
    return Promise.all(barcode_set_promises)
  },

  /**
   * Получить из REST баркодные коробочки
   */
  getBarcodeBoxes() {
    return session.get(
      '/barcode_box/'
    )
  },

  /**
   *  Получить остатки реактивов баркодов (набора баркодов в лаборатории)
   * @param query_list
   * @returns {AxiosPromise<any>}
   */
  getBarcodeRemains(query_list) {
    let query = ""

    if(query_list.length) {
      query = "?" + query_list.join("&")
    }
    return session.get(
      format(
        '/barcode_remains/{0}', query))
  },

  createBarcodeRemains(br) {
    return session.post(
      '/barcode_remains/', br
    )
  }
}

